// extracted by mini-css-extract-plugin
module.exports = {"periodContainer":"DatesDropdown__periodContainer___2HKXG","periodsLabel":"DatesDropdown__periodsLabel___2gOzB","periods":"DatesDropdown__periods___2qx-S"};